module.exports = __webpack_public_path__ + "img/warrior1.72585a7d.gif";